// extracted by mini-css-extract-plugin
export default {"favorites__list":"Favorites-module__favorites__list--cPnB1"};